import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { WeGoConfig } from './../../shared/config';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from './../../booking/models/booking.service';
import { SearchBookingModel } from './../../booking/models/search-booking.model';

const moment = require('moment');
@Component({
  selector: 'wego-search-booking-driver',
  template: require('../views/search-booking-driver.component.html'),
  styles: [
    `
      .box.box-default {
        border: 1px solid #ddd;
        border-top: 3px solid #2ba2aa;
      }
      .box-body {
        padding: 0px 10px 10px;
      }
      wego-geo-location-map {
        color: #000;
      }
      input#search-input {
        border: 1px solid #ccc;
      }
    `
  ]
})
export class SearchBookingDriverComponent
  implements OnInit, AfterViewInit, OnChanges {
  @Output('OnSearch') onSearch = new EventEmitter();
  @Input('SearchBookingModel')
  model: SearchBookingModel = new SearchBookingModel();
  @Input('IsDashboard') isDashboard: boolean = false;
  //@Input('IsDriverHashID') isDriverHashID: boolean = false;
  @ViewChild('flatPickrConfigFromDate')
  public flatPickrConfigFromDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDate')
  public flatPickrConfigToDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigEndDate')
  public flatPickrConfigEndDate: FlatPickrDirective;

  @ViewChild('flatPickrConfigFromDateSpl')
  public flatPickrConfigFromDateSpl: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDateSpl')
  public flatPickrConfigToDateSpl: FlatPickrDirective;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigEnd: FlatPickrModel;

  flatPickrConfigFromSpl: FlatPickrModel;
  flatPickrConfigToSpl: FlatPickrModel;

  isLoading: boolean;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  message: string;
  isenableTime: boolean;
  specialPeriodList: any[];
  searchRetainModal: any;
  //_isDHashID: boolean;
  private startDateTimeByTimeZone: string;

  @Input('IsDriverHashID')
  set IsDriverHashID(isDHashID: boolean) {
    console.log(isDHashID);
    if (isDHashID) {
      //this.AllowTimeForBooking();
      this.GetOrganizationList();
    }
  }

  @Input('TimezoneStartDateTime')
  set TimezoneStartDateTime(TimezoneStartDate: string) {    
    // this.model.startDateTime = TimezoneStartDate;
    this.startDateTimeByTimeZone = TimezoneStartDate;
  } 

  constructor(
    private bookingService: BookingService,
    private translate: TranslateService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnChanges(changes: any): void {
    console.log('NG Chaneg');
    console.log(changes);
  }

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig(true);

    this.flatPickrConfigFromSpl = this.SetDefaultSplPerFlatPickrConfig(true);
    this.flatPickrConfigToSpl = this.SetDefaultSplPerFlatPickrConfig(true);
    if (this.model) {
      this.searchRetainModal = Object.assign({}, this.model);
      this.OnOrganizationChange();
    }
  }

  private OnOrganizationChange() {
    if (this.model.organizationIdHashID) {
      this.AllowTimeForBooking();
      this.GetSpecialPeriodList();
     // this.handleChange(true,'REGULAR','');
      console.log(this.specialPeriodList);
    }
    // if (!this.isenableTime) {
    //   this.model.startDateTime = moment()
    //     .add('d', 1)
    //     .format('DD-MM-YYYY 00:00');
    //   this.model.endDateTime = moment(
    //     this.model.startDateTime,
    //     'DD-MM-YYYY 00:00'
    //   )
    //     .add('d', 1)
    //     .format('DD-MM-YYYY 00:00');
    // }
  }

  private GetSpecialPeriodList() {
    this.bookingService
      .GetSpecialPeriodList(this.model.organizationIdHashID , this.model.driverHashId)
      .subscribe(
        res => {
          this.specialPeriodList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  private SetDefaultSplPerFlatPickrConfig(
    //isDaySpecialPeriod: boolean,
    isDateOnly?: boolean
  ) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    // if (!isDaySpecialPeriod) {
    //   flatPickrConfig.enable = [
    //     (date: any) => {
    //       // return true to disable
    //       return date.getDay() === 5 || date.getDay() === 6;
    //     }
    //   ];
    // } else {
    //   flatPickrConfig.disable = [
    //     (date: any) => {
    //       // return true to disable
    //       return date.getDay() === 5 || date.getDay() === 6;
    //     }
    //   ];
    // }
    return flatPickrConfig;
  }

  private GetOrganizationList() {
    this.bookingService.GetOrganizationList(this.model.driverHashId).subscribe(
      res => {
        this.model.organizationList = res.data;

        if (
          this.model &&
          this.model.organizationList &&
          this.model.organizationList.length == 1
        ) {
          this.model.organizationIdHashID = this.model.organizationList[0].organizationMasterHashId;
          this.OnOrganizationChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public OnFromDateChange(value: string) {
    console.log(value);
    console.log(this.model.endDateTime);
    if (value && this.model.isRegularbooking) {
      let format = 'DD-MM-YYYY HH:mm';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      let endDateVal = moment(value, format);
      // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
      if (endDate <= newDate) {
        if (this.isenableTime) {
          endDateVal = endDateVal.add('H', 1);
        } else {
          endDateVal = endDateVal.add('d', 1);
        }
        // recurringEndDate = endDateVal.toDate();
        this.flatPickrConfigToDate.ChangeValue(
          endDateVal.format('DD-MM-YYYY HH:mm')
        );
      }
      this.flatPickrConfigToDate.SetOption('minDate', newDate);
      // if (this.flatPickrConfigEndDate) {
      //   this.flatPickrConfigEndDate.SetOption("minDate", recurringEndDate);
      // }
      // this.ChangeDateTimeForInputModel();
    }
  }

  public OnDayStartDateChange(value: string) {
    console.log(value);
    console.log(this.model.endDateTime);
    if (value) {
      let format = 'DD-MM-YYYY';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      let endDateVal = moment(value, format);

      if (endDate <= newDate) {
        endDateVal = endDateVal.add('d', 1);
        this.flatPickrConfigToDateSpl.ChangeValue(
          endDateVal.format('DD-MM-YYYY')
        );
      }
      this.flatPickrConfigToDateSpl.SetOption('minDate', newDate);
    }
    //this.ChangeDateTimeForInputModel();
  }

  public SetPickerValue(key: string, value: string) {
    // if (key == "SEARCH_FROM") {
    //   this.flatPickrConfigFromDate.ChangeValue(value);
    // }
    // if (key == "SEARCH_TO") {
    //   this.flatPickrConfigToDate.ChangeValue(value);
    // }
  }

  public ClearErrorModel() {
    this.errorModel = [];
  }

  private OnSearch(forms: any) {
    // if (!this.geoLocation) {
    //   this.geoLocationError = this.translate.instant('LblGeoLocationError');
    // }
    // else {
    //this.geoLocationError = '';
    let tempModel = Object.assign({}, this.model);

    if (!tempModel.isRegularbooking) {
      tempModel.startDateTime =
        tempModel.startDateTime.length <= 10
          ? tempModel.startDateTime + ' 00:00'
          : tempModel.startDateTime;
      tempModel.endDateTime =
        tempModel.endDateTime.length <= 10
          ? tempModel.endDateTime + ' 00:00'
          : tempModel.endDateTime;
    }

    this.CalculateBookingDuration(tempModel);
    tempModel.totalBookingDuration = this.model.totalBookingDuration;
    this.message = '';
    this.errorModel = null;
    this.isLoading = true;
    // if (!this.model.isRegularbooking) {
    //   this.model.startDateTime = this.model.startDateTime + ' 00:00';
    //   this.model.endDateTime = this.model.endDateTime + ' 00:00';
    // }
    this.bookingService.GetVehicleOverview(tempModel).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (!res.data) {
          this.errorModel = res.error;
        } else {
          if (res.data.length > 0)
            this.onSearch.emit({
              SearchModel: tempModel,
              VehicleOverview: res.data
            });
          else {
            this.message = res.error; //this.translate.instant('LblNoMatchingVehicle');
          }
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
    //this.ChangeDateTimeForInputModel();
    //}
  }

  public CalculateBookingDuration(searchModel: SearchBookingModel) {
    let format = 'DD-MM-YYYY HH:mm';
    let stDate = moment(searchModel.startDateTime, format).toDate();
    let enDate = moment(searchModel.endDateTime, format).toDate();
    // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
    //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
    // }
    let diffMs = enDate - stDate;
    var diffDays = Math.floor(diffMs / 86400000); // days
    var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

    if (diffDays > 0) {
      this.model.totalBookingDuration =
        diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs > 0) {
      this.model.totalBookingDuration = diffHrs + ' Hours ' + diffMins + ' Min';
    } else if (diffDays == 0 && diffHrs == 0) {
      this.model.totalBookingDuration = diffMins + ' Min';
    }
    console.log(this.model.totalBookingDuration);
  }

  // public GetAddress(place: Object) {
  //   // this.geoLocation = place['address'] != '' ? true : false;
  //   // this.model.companyGeoLocationLatitude = place['lat'];
  //   // this.model.companyGeoLocationLatitude = place['log'];
  //   this.model.sourceLocation = place['useraddressInput'];
  // }

  private SuccessSelectDriverModal($event: any) {
    this.model.driverHashId = $event.DriverHashID;
    this.model.driverName = $event.DriverName;
  }

  private AllowTimeForBooking() {
    if (this.model.driverHashId) {
      this.bookingService
        .AllowTimeForBooking(
          this.model.driverHashId,
          this.model.organizationIdHashID
        )
        .subscribe(
          res => {
            this.isenableTime = res.data;
            console.log(this.model);

            // if (!this.isenableTime) {
            //   this.model.startDateTime = moment()
            //     .add('d', 1)
            //     .format('DD-MM-YYYY 00:00');
            //   this.model.endDateTime = moment(
            //     this.model.startDateTime,
            //     'DD-MM-YYYY 00:00'
            //   )
            //     .add('d', 1)
            //     .format('DD-MM-YYYY 00:00');
            //   this.model.recurringPeriod = 'WEEKLY';
            // } else {
            //   this.model.startDateTime = moment()
            //     .add('m', 5)
            //     .format('DD-MM-YYYY HH:mm');
            //   this.model.endDateTime = moment()
            //     .add('H', 1)
            //     .add('m', 5)
            //     .format('DD-MM-YYYY HH:mm');
            //   this.model.recurringPeriod = 'DAILY';
            // }
            this.model.startDateTime = this.isenableTime
            ? moment(this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
                .add(5, 'minute')
                .format('DD-MM-YYYY HH:mm')
            : moment(this.startDateTimeByTimeZone)
                .add(1, 'd')
                .format('DD-MM-YYYY 00:00');
            this.model.endDateTime = this.isenableTime
            ? moment(this.model.startDateTime, 'DD-MM-YYYY HH:mm')
                .add(1, 'hour')
                .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
            : moment(this.model.startDateTime)
                .add(1, 'd')
                .format('DD-MM-YYYY 00:00');
            this.model.recurringPeriod = this.isenableTime ? 'DAILY' : 'WEEKLY';
            if (this.model.isRegularbooking) {
              this.flatPickrConfigFromDate.ToggleTimePicker(this.isenableTime);
              this.flatPickrConfigToDate.ToggleTimePicker(this.isenableTime);
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          },
          () => {
            console.log("this.searchRetainModal");
            console.log(this.searchRetainModal);
            if (this.searchRetainModal.startDateTime || this.searchRetainModal.endDateTime) {
              // this.model.startDateTime = this.searchRetainModal.startDateTime;
              // this.model.endDateTime = this.searchRetainModal.endDateTime;
            }
            if (!this.model.isRegularbooking) {
              this.ClearTimeSpanForSpecialPeriod();
            }
          }
        );
    }
  }

  public PickupLocation($event: any) {
    this.model.pickupAddress = $event.address;
    this.model.pickupLat = $event.lat;
    this.model.pickupLong = $event.long;
  }

  public ResetLocationField() {
    this.model.pickupAddress = '';
    this.model.pickupLat = 0;
    this.model.pickupLong = 0;
  }

  public handleChange(
    changeVal: any,
    periodType: any,
    contractTypeHashID: string
  ) {
    this.model.isRegularbooking = changeVal;
    this.model.specialPeriodType = periodType;
    this.model.contractTypeHashId = contractTypeHashID;
    this.model.isRecurring = false;
    this.model.recurringEndDateTime = '';

    this.ChangeDateTimeForInputModel();

    if (!this.model.isRegularbooking && this.flatPickrConfigToDateSpl) {
      this.flatPickrConfigToDateSpl.ChangeValue(this.model.endDateTime);
    }
  }

  private ChangeDateTimeForInputModel() {
    if (!this.model.isRegularbooking) {
      this.model.startDateTime = moment()
        .add('d', 1)
        .format('DD-MM-YYYY 00:00');
      this.model.endDateTime = moment(
        // this.model.startDateTime,
        // 'DD-MM-YYYY 00:00'
      )
        .add('d', 1)
        .format('DD-MM-YYYY 00:00');
      this.ClearTimeSpanForSpecialPeriod();
    } else {
      if (!this.isenableTime) {
        this.model.startDateTime = moment()
          .add('d', 1)
          .format('DD-MM-YYYY 00:00');
        this.model.endDateTime = moment(
          this.model.startDateTime,
          'DD-MM-YYYY 00:00'
        )
          .add('d', 1)
          .format('DD-MM-YYYY 00:00');
      } else {
        this.model.startDateTime = moment()
          .add('m', 5)
          .format('DD-MM-YYYY HH:mm');
        this.model.endDateTime = moment()
          .add('H', 1)
          .add('m', 5)
          .format('DD-MM-YYYY HH:mm');
      }
    }
  }

  private ClearTimeSpanForSpecialPeriod() {
    this.model.startDateTime = this.model.startDateTime.substring(0, 10);
    this.model.endDateTime = this.model.endDateTime.substring(0, 10);
  }

  ngAfterViewInit() {
    //this.OnFromDateChange(this.model.startDateTime);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-driver/components/search-booking-driver.component.ts